<template>
  <div class="view product">

    <product-detail :item="model"/>  

  </div>
</template>

<script>
import Product from '@/models/Product';
import Category from '@/models/Category';
import PAP from '@/mixins/pap';
import ProductDetail from '@/components/ProductDetail.vue'


export default {
  props: ['id'],
  mixins: [ PAP ],

  data() {
    return {
      type: 'product', // for breadcrumbs
    }
  },

  computed: {
    model() {
      return Product.find(this.id) || new Product();
    },
  },

  created() {
    this.load();
  },

  methods: {
    load() {
      Product.fetch(this.id).then(() => {
        Category.fetch(this.type, this.model.category);        
      });
    }
  },

  components: {
    ProductDetail
  }

}
</script>

<style lang="scss">
.view.product {
  padding-top: 40px;
}
</style>